// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ShippingDetailsModal__wrapper__2S81r"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal.scss
// module id = 1720
// module chunks = 4 14